var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-none flex items-center justify-center cursor-pointer text-center rounded-xl py-1.5 px-2",class:[
    _vm.buttonClass,
    _vm.filledChipsStyle ? 'mx-1 mb-2' : 'mx-2 mb-6'
  ],on:{"click":_vm.itemSelected}},[_c(_vm.item.icon,{tag:"component",staticClass:"flex-shrink-0 w-6 h-6 mr-1"}),_vm._v(" "),_c('span',{staticClass:"text-xs"},[_vm._v(_vm._s(_vm.$t(_vm.item.title) || _vm.$t(_vm.item.name)))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }